import { useEffect } from 'react';

import { inMemoryPersistence, onAuthStateChanged } from 'firebase/auth';

import { useCreateAuthCookies, useCreateRefreshCookies } from '@/features/auth/api/auth-cookies';
import { useAuthenticated } from '@/features/auth/api/authenticated';
import { auth } from '@/lib/firebase';

export function useAuth() {
  const { createAuthCookie } = useCreateAuthCookies();
  const { createRefreshCookie } = useCreateRefreshCookies();
  const authenticated = useAuthenticated();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Doesn't work without this empty dependency array, better solution very welcome
  useEffect(() => {
    auth.setPersistence(inMemoryPersistence);

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const idToken = await currentUser.getIdToken();
        createAuthCookie.mutate(idToken);

        const refreshToken = currentUser.refreshToken;
        if (refreshToken) {
          createRefreshCookie.mutate(refreshToken);
        }
      }
    });

    return unsubscribe;
  }, []); // Doesn't work without this empty dependency array, better solution very welcome

  return authenticated;
}
